import { render, staticRenderFns } from "./Popups.vue?vue&type=template&id=d9215506&scoped=true"
import script from "./Popups.vue?vue&type=script&lang=js"
export * from "./Popups.vue?vue&type=script&lang=js"
import style0 from "./Popups.vue?vue&type=style&index=0&id=d9215506&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9215506",
  null
  
)

export default component.exports